import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

// Event names for EventPane tracking
const EVENT_PANE_EVENT_NAMES = {
  TAB_OPEN: 'event_pane_tab_open',
  PANE_OPEN: 'event_pane_open',
  PANE_CLOSE: 'event_pane_close',
};

/**
 * Tracks when a tab is opened in the EventPane
 * @param {string} tabId - The ID of the tab opened (e.g., 'overview')
 */
export const trackEventPaneTabOpen = ({ tabId }) => {
  gspx.trackEvent({
    name: EVENT_PANE_EVENT_NAMES.TAB_OPEN,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.EVENT_PANE_NAVIGATION,
    capability: GPX_CAPABILITIES.UNITE_EVENT_PANE,
    route: GPX_ROUTES.EVENT_PANE,
    entities: {
      tab_name: tabId,
    },
    additionalKeys: {},
  });
};

/**
 * Tracks when the EventPane is opened for a call
 */
export const trackEventPaneOpen = () => {
  gspx.trackEvent({
    name: EVENT_PANE_EVENT_NAMES.PANE_OPEN,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.EVENT_PANE_NAVIGATION,
    capability: GPX_CAPABILITIES.UNITE_EVENT_PANE,
    route: GPX_ROUTES.EVENT_PANE,
  });
};

/**
 * Tracks when the EventPane is closed
 */
export const trackEventPaneClose = () => {
  gspx.trackEvent({
    name: EVENT_PANE_EVENT_NAMES.PANE_CLOSE,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.EVENT_PANE_NAVIGATION,
    capability: GPX_CAPABILITIES.UNITE_EVENT_PANE,
    route: GPX_ROUTES.EVENT_PANE,
  });
};
